import React from "react";

const IArrowRounded2 = ({
  color = "#FAFAFA",
  width = "32",
  height = "32",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        d="M27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
        fill={color}
      />
      <path
        d="M18.0404 11.293C17.6742 10.9268 17.0946 10.9035 16.7018 11.224L16.6263 11.293L12.6263 15.293C12.2358 15.6835 12.2358 16.3165 12.6263 16.707L16.6263 20.707C17.0168 21.0976 17.6498 21.0976 18.0404 20.707C18.4309 20.3165 18.4309 19.6835 18.0404 19.293L14.7474 16L18.0404 12.707L18.1094 12.6315C18.4298 12.2387 18.4065 11.6591 18.0404 11.293Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrowRounded2;
